import { HouseDocumentAggregates } from '@/hooks/house/documents/useHouseRecordStatus';

/**
 * Computes a 0–100 progress value for the KB indexing banner by counting
 * each of the three pipeline phases (bnd_v2, metadata, kbs) individually.
 * This gives a more progressive feel: with N files there are 3N total steps,
 * so progress advances as each phase completes rather than only at the end.
 */
export function computeKbProgressValue(
	aggregates: Pick<HouseDocumentAggregates, 'total_docs' | 'bnd' | 'metadata' | 'kbs' | 'all_completed'>,
): number {
	const { total_docs, bnd, metadata, kbs, all_completed } = aggregates;

	if (all_completed) return 100;

	const totalSteps = total_docs * 3;
	if (totalSteps === 0) return 0;

	const completedSteps = bnd.completed + metadata.completed + kbs.completed;
	return Math.round((completedSteps / totalSteps) * 100);
}

/**
 * Overall record-processing progress used on Records. It follows both terminal branches by adding
 * document enrichment to the KB phases, so the wheel cannot reach 100 while tags or summaries are
 * still being generated.
 */
export function computeDocumentProgressValue(
	aggregates: Pick<
		HouseDocumentAggregates,
		'total_docs' | 'bnd' | 'metadata' | 'kbs' | 'documentEnrichment' | 'all_completed'
	>,
): number {
	const { total_docs, bnd, metadata, kbs, documentEnrichment } = aggregates;
	const totalSteps = total_docs * 4;
	if (totalSteps === 0) return 0;

	const completedSteps = bnd.completed + metadata.completed + kbs.completed + documentEnrichment.completed;
	return Math.round((completedSteps / totalSteps) * 100);
}
